export const getArrayChunk = <T>(array: T[], size: number) => Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
  array.slice(i * size, i * size + size)
);

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));